/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ImportTypeEnum,
    ImportTypeEnumFromJSON,
    ImportTypeEnumFromJSONTyped,
    ImportTypeEnumToJSON,
} from './ImportTypeEnum';

/**
 * 
 * @export
 * @interface CreateImporterDto
 */
export interface CreateImporterDto {
    /**
     * 
     * @type {ImportTypeEnum}
     * @memberof CreateImporterDto
     */
    id: ImportTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateImporterDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateImporterDto
     */
    blacklist?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateImporterDto
     */
    isEnabled?: boolean;
}

export function CreateImporterDtoFromJSON(json: any): CreateImporterDto {
    return CreateImporterDtoFromJSONTyped(json, false);
}

export function CreateImporterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateImporterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': ImportTypeEnumFromJSON(json['id']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'blacklist': !exists(json, 'blacklist') ? undefined : json['blacklist'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
    };
}

export function CreateImporterDtoToJSON(value?: CreateImporterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': ImportTypeEnumToJSON(value.id),
        'description': value.description,
        'blacklist': value.blacklist,
        'isEnabled': value.isEnabled,
    };
}

